/**
 * Directory groups and names for ids (AIOE's own; the workbench need not copy it). The console's
 * pickers ask Microsoft Graph with the person's own token first; when that token cannot be had
 * (consent not granted, Graph refuses), these answer instead, asked of Graph as the AIOE API
 * application, so nobody has to type or paste an object id.
 *
 *   GET  /people/v1/groups?q=<2+ characters>&limit=20     a person's sign-in or a desktop's device token
 *        → { available, groups: [{ id, name, detail? }], more }
 *   POST /people/v1/subjects   { ids: [≤ 200] }            the same tokens
 *        → { subjects: [{ id, type, name, detail? }], missing: [ids] }
 *
 * `available` is false on Mojo Up AI Cloud (it has no directory groups) and wherever the API
 * application cannot read the Entra directory: a client then offers people only. A group's `id` is
 * its Entra object id, which project members, business-area managers, memory clearances and
 * compartment grants, role assignments and node assignments store as `subjectId`. `subjects` names
 * people from their sign-ins (and Cloud's members) and people and groups from Entra; an id nobody
 * knows is in `missing` (a person who left, a deleted group). Group membership is never read from
 * here: access follows the person's own sign-in (api auth/groups.ts).
 */
import { z } from "zod";
export const DIRECTORY_SUBJECTS_MAX = 200;
export const directoryGroupSchema = z.object({
    id: z.string().min(1).max(200),
    name: z.string().min(1).max(300),
    /** The group's email or description. */
    detail: z.string().max(1000).optional(),
});
export const directorySubjectsRequestSchema = z.object({ ids: z.array(z.string().min(1).max(200)).max(DIRECTORY_SUBJECTS_MAX) });
//# sourceMappingURL=directorySubjects.js.map